import { render } from "./showresultadminView.vue?vue&type=template&id=780c74f2&scoped=true"
import script from "./showresultadminView.vue?vue&type=script&lang=js"
export * from "./showresultadminView.vue?vue&type=script&lang=js"

import "./showresultadminView.vue?vue&type=style&index=0&id=780c74f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780c74f2"]])

export default __exports__